import At from "../../assets/images/flags/at.svg?react";

export default At;
